import PropTypes from 'prop-types'

import {connect} from 'react-redux'
import {createResource, readEndpoint} from 'redux-json-api'
import {useState} from 'react'

import ConfirmationModal from '../../../../../shared_components/mui_base_components/modals/confirmation_modal/ConfirmationModal'
import LinkButton from '../../../../../shared_components/mui_base_components/link_button/LinkButton'
import {useNotificationContext} from '../../../../../shared_components/notifications/NotificationContext'

export const DowngradeClientController = ({clientName, clientSeatId, ...otherProps}) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isDowngrading, setIsDowngrading] = useState(false)

  const {alwaysNotify} = useNotificationContext()

  const closeModal = () => {
    if (!isDowngrading) setIsModalVisible(false)
  }

  const downgradeClient = () => {
    setIsDowngrading(true)

    otherProps.createResource({
      type: 'preneed-client-downgrades',
      attributes: {'client-seat-id': clientSeatId}
    })
      .then(() => otherProps.readEndpoint(`client-seats/${clientSeatId}`))
      .then(() => {
        setIsDowngrading(false)
        setIsModalVisible(false)

        alwaysNotify.shortSuccess(`${clientName} has been downgraded.`)
      })
      .catch(() => {
        setIsDowngrading(false)

        alwaysNotify.shortError('Unable to downgrade this client. Please try again.')
      })
  }

  return (
    <>
      <LinkButton
        className='downgrade-client-link'
        data-testid='downgrade-client-link'
        onClick={() => setIsModalVisible(true)}>
        Downgrade
      </LinkButton>
      {
        isModalVisible && (
          <ConfirmationModal
            bodyText={
              `${clientName} will lose access to all Premium features.`
            }
            confirmButtonText='Downgrade'
            headingText={`Downgrade ${clientName} to Everplans free?`}
            loading={isDowngrading}
            onClose={closeModal}
            onConfirmation={downgradeClient}
            open={isModalVisible}
          />
        )
      }
    </>
  )
}

DowngradeClientController.propTypes = {
  clientName: PropTypes.string.isRequired,
  clientSeatId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  createResource: PropTypes.func,
  readEndpoint: PropTypes.func
}

export default connect(null, {createResource, readEndpoint})(DowngradeClientController)
